import { render, staticRenderFns } from "@/templates/document/resourceDetail.html?vue&type=template&id=32d89344&"
import script from "./ResourceDetail.vue?vue&type=script&lang=js&"
export * from "./ResourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports